var map = {
	"./bigTruck/bigTruck-blue.png": "3fee",
	"./bigTruck/bigTruck-dark-grey.png": "48ff",
	"./bigTruck/bigTruck-green.png": "7146",
	"./bigTruck/bigTruck-grey.png": "820d",
	"./bigTruck/bigTruck-orange.png": "39a8",
	"./bigTruck/bigTruck-red.png": "e890",
	"./bus/bus-blue.png": "cc90",
	"./bus/bus-dark-grey.png": "e223",
	"./bus/bus-green.png": "0d7a",
	"./bus/bus-grey.png": "d558",
	"./bus/bus-orange.png": "151e",
	"./bus/bus-red.png": "f448",
	"./car/car-blue.png": "8abd",
	"./car/car-dark-grey.png": "6316",
	"./car/car-green.png": "d42a",
	"./car/car-grey.png": "933e",
	"./car/car-orange.png": "c34e",
	"./car/car-red.png": "2760",
	"./container/container-blue.png": "abfa",
	"./container/container-dark-grey.png": "33ab",
	"./container/container-green.png": "420a",
	"./container/container-grey.png": "c4be",
	"./container/container-orange.png": "2048",
	"./container/container-red.png": "7932",
	"./doubleCabin/doubleCabin-blue.png": "028a",
	"./doubleCabin/doubleCabin-dark-grey.png": "4ea0",
	"./doubleCabin/doubleCabin-green.png": "eab1",
	"./doubleCabin/doubleCabin-grey.png": "4741",
	"./doubleCabin/doubleCabin-orange.png": "8a52",
	"./doubleCabin/doubleCabin-red.png": "f531",
	"./doubleCabin/doubleCabin-yellow.png": "49a8",
	"./electricCar/electricCar-blue.png": "ffe4",
	"./electricCar/electricCar-dark-grey.png": "9873",
	"./electricCar/electricCar-green.png": "3097",
	"./electricCar/electricCar-grey.png": "7f2c",
	"./electricCar/electricCar-orange.png": "0b05",
	"./electricCar/electricCar-red.png": "7617",
	"./electricMotorcycle/electricMotorcycle-blue.png": "16b8",
	"./electricMotorcycle/electricMotorcycle-dark-grey.png": "60e2",
	"./electricMotorcycle/electricMotorcycle-green.png": "a5f8",
	"./electricMotorcycle/electricMotorcycle-grey.png": "e57a",
	"./electricMotorcycle/electricMotorcycle-orange.png": "aad8",
	"./electricMotorcycle/electricMotorcycle-red.png": "10a5",
	"./excavator/excavator-blue.png": "881b",
	"./excavator/excavator-dark-grey.png": "c550",
	"./excavator/excavator-green.png": "25a6",
	"./excavator/excavator-grey.png": "90dd",
	"./excavator/excavator-orange.png": "d606",
	"./excavator/excavator-red.png": "3ef8",
	"./motorcycle/motorcycle-blue.png": "97b4",
	"./motorcycle/motorcycle-dark-grey.png": "b8a6",
	"./motorcycle/motorcycle-green.png": "cab3",
	"./motorcycle/motorcycle-grey.png": "fcc1",
	"./motorcycle/motorcycle-orange.png": "478f",
	"./motorcycle/motorcycle-red.png": "18e2",
	"./smallTruck/smallTruck-blue.png": "e0ff",
	"./smallTruck/smallTruck-dark-grey.png": "b437",
	"./smallTruck/smallTruck-green.png": "4b45",
	"./smallTruck/smallTruck-grey.png": "c897",
	"./smallTruck/smallTruck-orange.png": "d4a7",
	"./smallTruck/smallTruck-red.png": "af62",
	"./tractor/tractor-blue.png": "a44b",
	"./tractor/tractor-dark-grey.png": "2d98",
	"./tractor/tractor-green.png": "4e97",
	"./tractor/tractor-grey.png": "9b87",
	"./tractor/tractor-orange.png": "d019",
	"./tractor/tractor-red.png": "6284",
	"./tractor/tractor-yellow.png": "5c51",
	"./truckHead/truckHead-blue.png": "33a6",
	"./truckHead/truckHead-dark-grey.png": "8bf1",
	"./truckHead/truckHead-green.png": "ea37",
	"./truckHead/truckHead-grey.png": "4c48",
	"./truckHead/truckHead-orange.png": "0298",
	"./truckHead/truckHead-red.png": "5c83",
	"./truckHead/truckHead-yellow.png": "06dd",
	"./van/van-blue.png": "3759",
	"./van/van-dark-grey.png": "ebe9",
	"./van/van-green.png": "1619",
	"./van/van-grey.png": "7854",
	"./van/van-orange.png": "52d9",
	"./van/van-red.png": "0b39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "228a";